import SNSLogin from "./snslogin";

$(document).ready(function() {
    $("#wgbg_join_btn").on("click", e => {
        e.preventDefault();
        location.href = "/member/join_provision.htm";
    });
    SNSLogin.init("join");
});



// WEBPACK FOOTER //
// ./member/js/join_home.js